//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';

type ReadProps = {
  mT?: string;
};

export const GeorgesChakraFW2324 = ({ mT }: ReadProps) => {
  return (
    <>
      {/* <span style={{ fontSize: '13px', marginTop: mT }}>Haute Couture</span> */}
      <h3 style={{ marginTop: mT }}>GEORGES CHAKRA</h3>
      <span style={{ fontSize: '13px' }}>FALL / WINTER 2023 - 2024</span>
      <div>
        <video
          controls={true}
          controlsList="nodownload"
          playsInline
          muted
          autoPlay
          loop
          style={{ width: '100%', maxWidth: '100%' }}
        >
          <source
            src={
              '/media/georgeschakra.mp4'
            }
            type="video/mp4"
          />
        </video>
      </div>
      <Link className="fullStory" href="/ReadCouture1">Read the Collection Story</Link>
      <h4>THE SPLENDOR...</h4>
      <p className="topPargraph" style={{margin: 0}}>
        Gold and black are a captivating duo that evokes elegance, intrigue, and
        power. Splendour adds a sense of magnificence to this combination,
        conjuring images of grand palaces adorned with intricate gold
        decorations, shimmering ballrooms filled with laughter and music, and
        breathtaking landscapes bathed in the golden light of dawn. Gold,
        symbolizing wealth, adds opulence to this tapestry. It transforms the
        ordinary into the extraordinary, lending an air of sophistication and
        timeless beauty. Black, representing mystery and depth, provides a
        striking contrast. It grounds the vibrancy of gold, adding a touch of
        intrigue and drama. Together, these three elements create a powerful
        synergy. Imagine a grand hall with black marble walls, gleaming under
        the soft glow of golden chandeliers. Or picture a woman in a flowing
        black gown, her dress adorned with delicate gold embroidery, a symbol of
        both strength and elegance. The combination is both bold and
        sophisticated, captivating the eye and igniting the imagination. This is
        the essence of the splendorous dance between gold and black. It's a
        timeless combination that transcends trends and cultures, a testament to
        the enduring power of beauty, mystery, and the pursuit of excellence.
        Gold and black exude opulence and sophistication. These two colours have
        long been associated with wealth, prestige, and glamour. Gold symbolizes
        wealth, success, and abundance, often adorning the regalia of kings and
        emperors. When paired with black, gold takes on an even more striking
        presence, creating a sense of drama and grandeur. Black, on the other
        hand, represents elegance, mystery, and sophistication. It is a classic
        colour that never goes out of style, adding a sense of timelessness to
        any design. When combined with gold, black becomes even more luxurious,
        providing a bold contrast that commands attention and leaves a lasting
        impression. Whether used in interior design, fashion, or artwork, the
        combination of gold and black evokes a sense of luxury and refinement.
        From extravagant chandeliers dripping with gold embellishments to sleek
        black evening gowns adorned with golden accents, this striking duo never
        fails to captivate and enthral. In a world filled with fleeting trends
        and fads, the timeless allure of gold and black continues to reign
        supreme, reminding us that true splendour is found in the elegant
        simplicity of these two majestic colours.
        <br />
        <br />
        <b>Splendor</b> paints a picture of magnificence, a sense of
        awe-inspiring grandeur. It conjures images of vast palaces adorned with
        intricate gold decorations, shimmering ballrooms filled with laughter
        and music, and breathtaking landscapes bathed in the golden light of
        dawn.
        <br />
        <br />
        <b>Gold</b>, the very essence of wealth and royalty, adds a touch of
        opulence to this tapestry. It symbolizes achievement, success, and the
        warmth of the sun. Gold accents can transform the ordinary into the
        extraordinary, lending an air of sophistication and timeless beauty.
        <br />
        <br />
        <b>Black</b>, the color of mystery and depth, provides a striking
        contrast. It grounds the vibrancy of gold, adding a touch of intrigue
        and drama. Black represents strength, sophistication, and the vastness
        of the unknown. Together, these three elements create a powerful
        synergy.
      </p>
    </>
  );
};
